
module.exports = {
    setupFWPCategories
}

async function wait(milliseconds) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(); // Resolve the promise after the specified time
      }, milliseconds);
    });
  }

function updateAccordionLabel(categoryName) {
    const $ = jQuery;
    const accordionLabel = $('#select-cat-link');

    const startCaseCategory = categoryName.charAt(0).toUpperCase() + categoryName.substring(1);
    accordionLabel.html(startCaseCategory)
}
  
function setupFWPCategories() {
    const $ = jQuery;
    const categories = $('.facetwp-radio');

    const defaultLabel = 'Select a category';

    categories.each(function (index, category) {
        $(category).on('click', function() {
            console.log("cat clicked", category)
            // change the dropdown label

            const categoryName = $(this).data('value') + " ";

            console.log("before wait")
            wait(3000).then(function () {
                console.log('after wait')
                const is_checked = $(this).hasClass('checked');
                if (!is_checked) {
                    console.log("setting class after wait")
                    updateAccordionLabel(categoryName)
                    $('#shop-filters').removeClass("show"); // added this
                } else {
                    // change the dropdown label to the default
                    updateAccordionLabel(defaultLabel)
                }
            })
        })
    })
    

    // $().on('click', '.facetwp-type-radio .facetwp-radio:not(.disabled)', function() {
        // console.log("clicked")
        // var is_checked = $(this).hasClass('checked');
        // $(this).closest('.facetwp-facet').find('.facetwp-radio').removeClass('checked');
        // // if (! is_checked) {
        // //     $(this).addClass('checked');
        // // }
        // // FWP.autoload();
        //  const timeoutId = setTimeout(function() {
        //     console.log("timeout fired")
        //     if (! is_checked) {
        //         $(this).addClass('checked');
        //         $('#shop-filters').removeClass("show"); // added this
        //     }
        // }, 500)
        // return clearTimeout(timeoutId);
    // });
}
    
//     $().on('click', '.facetwp-type-radio .facetwp-radio:not(.disabled)', function() {
//      var is_checked = $(this).hasClass('checked');
//      $(this).closest('.facetwp-facet').find('.facetwp-radio').removeClass('checked');

//      setTimeout(function() {
//         if (! is_checked) {
//             $(this).addClass('checked');
//             $('#shop-filters').removeClass("show"); // added this
//         }
//     }, 500)
//     FWP.autoload();
// });
